const challengesContainer = document.querySelectorAll('.cards-container')

challengesContainer.forEach(element => {
    const loadMore = element.querySelector('.add-cards')
    
    loadMore.addEventListener('click', () => {
        const cards = element.querySelectorAll('.d-none')
        cards[0].classList.remove('d-none')
        if (cards.length >= 2) {
            cards[1].classList.remove('d-none')
        }
        if (cards.length <= 2) {
            loadMore.classList.add('d-none')
        }
    })
});